import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgButtonX = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 7,
	height: 6,
	viewBox: "0 0 7 6",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.56841 3.66607L5.53892 5.63657C5.71839 5.81604 6.01611 5.8084 6.20503 5.61949C6.39394 5.43057 6.40158 5.13285 6.22211 4.95338L4.2516 2.98288L6.32582 0.908664C6.51473 0.719748 6.52237 0.422024 6.3429 0.242553C6.16343 0.0630831 5.8657 0.070717 5.67679 0.259633L3.60257 2.33384L1.63207 0.363344C1.4526 0.183873 1.15488 0.191507 0.965962 0.380423C0.871746 0.47464 0.822488 0.596421 0.819396 0.717018C0.816303 0.837615 0.859377 0.957028 0.948882 1.04653L2.91938 3.01703L0.845172 5.09125C0.750955 5.18546 0.701697 5.30724 0.698605 5.42784C0.695513 5.54844 0.738587 5.66785 0.828092 5.75736C1.00756 5.93683 1.30529 5.92919 1.4942 5.74028L3.56841 3.66607Z",
		fill: "#26294B"
	})]
});
const ForwardRef = forwardRef(SvgButtonX);
export { ForwardRef as ReactComponent };
